module.exports = __webpack_public_path__ + "static/media/foryou2.94d8e841.jpg";